import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCentreMapinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 2v16.356L1 22V5.646zm14 0v16.356L15 22V5.646zM8 2v16.356L15 22V5.646z",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgCentreMapinline;
